import { Link } from "react-router-dom";
import RevealSection from "@/components/base/RevealSection";

export default function ThankYou() {
  return (
    <RevealSection>
    <section className="bg-white px-4 md:px-8 lg:px-12 py-16 md:py-24">
      <div className="max-w-3xl mx-auto text-center mb-10 md:mb-14">
        <div className="w-20 h-20 rounded-full bg-teal/10 flex items-center justify-center mx-auto mb-8">
          <i className="ri-check-line text-teal text-4xl" />
        </div>
        <h1 className="text-3xl md:text-4xl lg:text-[48px] font-bold text-navy mb-6">
          Message Received
        </h1>
        <p className="text-navy/70 text-lg md:text-xl leading-relaxed">
          Thank you for reaching out. Katia will get back to you as soon as
          possible. In the meantime, explore these resources.
        </p>
      </div>

      <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-6 lg:gap-8">
        <div className="bg-white border border-seafoam/40 rounded-xl p-6 md:p-8 text-center hover:shadow-md transition-shadow duration-300">
          <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mx-auto mb-4">
            <i className="ri-questionnaire-line text-teal text-2xl" />
          </div>
          <h3 className="text-lg md:text-xl font-semibold text-navy mb-2">
            Take the Quiz
          </h3>
          <p className="text-navy/60 text-sm md:text-base leading-relaxed mb-5">
            Discover your communication style with a quick diagnostic.
          </p>
          <Link
            to="/quiz"
            className="text-teal font-semibold text-sm hover:underline"
          >
            Start Quiz
          </Link>
        </div>

        <div className="bg-white border border-seafoam/40 rounded-xl p-6 md:p-8 text-center hover:shadow-md transition-shadow duration-300">
          <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mx-auto mb-4">
            <i className="ri-flow-chart text-teal text-2xl" />
          </div>
          <h3 className="text-lg md:text-xl font-semibold text-navy mb-2">
            Decision Tree
          </h3>
          <p className="text-navy/60 text-sm md:text-base leading-relaxed mb-5">
            Identify what kind of conversation you need and get started.
          </p>
          <Link
            to="/decision-tree"
            className="text-teal font-semibold text-sm hover:underline"
          >
            Explore
          </Link>
        </div>

        <div className="bg-white border border-seafoam/40 rounded-xl p-6 md:p-8 text-center hover:shadow-md transition-shadow duration-300">
          <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mx-auto mb-4">
            <i className="ri-file-text-line text-teal text-2xl" />
          </div>
          <h3 className="text-lg md:text-xl font-semibold text-navy mb-2">
            Script Pack
          </h3>
          <p className="text-navy/60 text-sm md:text-base leading-relaxed mb-5">
            Get word-for-word scripts for every difficult workplace situation.
          </p>
          <a
            href="https://katiahunt.gumroad.com/l/scripts"
            target="_blank"
            rel="noopener noreferrer"
            className="text-teal font-semibold text-sm hover:underline"
          >
            Get Scripts
          </a>
        </div>
      </div>
    </section>
    </RevealSection>
  );
}